import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import ControlGroupExecuteForm from '../../../components/forms/ControlGroupExecuteForm'
import Popup from '../../../components/elements/Popup'

import Types from '../../../actions/Types'
import GetAction from '../../../actions/controlGroups/GetAction'
import ExecuteAction from '../../../actions/controlGroups/ExecuteAction'
import ClearErrorAction from '../../../actions/app/ClearErrorAction'

class ExecuteControlGroupPopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      submit: null
    }

    // Bind events
    this.submit = this.submit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    this.props.get(this.props.id)
  }

  componentDidUpdate(prevProps, prevState) {
    // If fetch is error, close with error
    if (
      prevProps.isLoading
      &&
      !this.props.isLoading
      &&
      this.props.loadError
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.FAILURE, "Impossible d'obtenir les infos sur ce groupe.")
      this.props.onClose(false)
    }

    // When successful, close popup
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.error
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.SUCCESS, 'Contrôle enregistré.')
      this.props.onClose(true)
    }
  }

  submit() {
    if (_.isFunction(this.state.submit)) {
      this.state.submit()
    }
  }

  onSubmit(data) {
    this.props.execute(this.props.id, data)
  }

  render() {
    return (
      <Popup
        header='Enregistrer un contrôle'
        body={
          <ControlGroupExecuteForm
            group={this.props.data}
            onSubmit={this.onSubmit}
            onClearError={this.props.clearError}
            isLoading={this.props.isLoading}
            isSaving={this.props.isSaving}
            registerSubmit={(submit) => { this.setState({ submit })}}
            error={this.props.error}
          />
        }
        footer={[
          {
            type: Popup.BUTTONTYPE.CLOSE,
            title: 'Annuler',
            color: 'red',
            icon: 'close',
            basic: true,
            onClick: () => this.props.onClose(false)
          },
          {
            type: Popup.BUTTONTYPE.SUBMIT,
            title: 'Enregistrer',
            color: 'green',
            icon: 'checkmark',
            onClick: this.submit
          }
        ]}
        isLoading={this.props.isLoading}
        isSaving={this.props.isSaving}
      />
    )
  }
}

ExecuteControlGroupPopup.propTypes = {
  // Properties
  id: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,

  // Redux State
  data: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  loadError: PropTypes.object,
  isSaving: PropTypes.bool.isRequired,
  saveError: PropTypes.object,

  // Redux Actions
  get: PropTypes.func.isRequired,
  execute: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    data: state.entities.controls.group.get.data,
    isLoading: state.entities.controls.group.get.isFetching,
    loadError: state.entities.controls.group.get.error,
    isSaving: state.entities.controls.group.execute.isFetching,
    saveError: state.entities.controls.group.execute.error,
  }),
  (dispatch) => ({
    get: (id) => (dispatch(GetAction({ id }))),
    execute: (id, data) => (dispatch(ExecuteAction({ id, data }))),
    clearError: () => (dispatch(ClearErrorAction(Types.CTRL_GROUPS.EXECUTE)))
  })
)(ExecuteControlGroupPopup)



// WEBPACK FOOTER //
// ./src/containers/popups/controlGroups/ExecuteControlGroupPopup.js